import l from "@/locale";
import { selectCurrentProperty } from "@/store/property/propertySelector";
import useAppDispatch from "@hooks/useAppDispatch";
import { fetchProperty } from "@store/property/propertyThunk";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const POLL_INTERVAL_SECONDS = 30;

export type PmsSyncStateNotification = {
  type: "warning" | "negative";
  heading: string;
  content: string;
};

const usePmsSyncStateNotification = ():
  | PmsSyncStateNotification
  | undefined => {
  const dispatch = useAppDispatch();
  const currentProperty = useSelector(selectCurrentProperty);

  useEffect(() => {
    if (!currentProperty) return;
    const intervalCallback = () => {
      dispatch(fetchProperty(currentProperty.id));
    };
    const interval = setInterval(
      intervalCallback,
      POLL_INTERVAL_SECONDS * 1000,
    );

    return () => clearInterval(interval);
  }, [currentProperty]);

  if (!currentProperty || currentProperty.code === "GOE") return;
  const { pmsSyncState } = currentProperty;
  const showNotification = pmsSyncState !== "good";

  if (!showNotification) return;

  return {
    type: pmsSyncState === "bad" ? "negative" : "warning",
    heading: l.t(`pmsNotification.heading.${pmsSyncState}`),
    content: l.t(`pmsNotification.content.${pmsSyncState}`),
  };
};

export default usePmsSyncStateNotification;
